Creates a new position opening.

Every position profile belongs to a position opening.
Up to 25 position profiles may belong to the same position opening.
